import {share} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable ,  Observer } from 'rxjs';

@Injectable()
export class ModalService{

	alert$: Observable<string>;
	// alert: (msgKey: string) => void;
	confirm: (msgKey: string, titleKey?: string, noKey?: string, yesKey?: string) => Promise<boolean>;
	warn: (msgKey: string) => Promise<boolean>;
    notify: (msgKey: string, title : string, buttonText : string) => Promise<boolean>;

	private _alertObserver: Observer<string>;

	constructor() {
		this.alert$ = new Observable<string>(
			(observer: any) => this._alertObserver = observer).pipe(share());
	}

	alert (msgKey: string) {
		if (this._alertObserver) {
			this._alertObserver.next(msgKey);
		}
	}

}